import axios from "axios";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { getApiHeader } from 'utlis/commonfunctions';
import '@fortawesome/fontawesome-free/css/all.min.css';

import { useSoftUIController, setMiniSidenav } from "context";

import { Oval } from "react-loader-spinner";
import { Backdrop, CircularProgress } from "@mui/material";


const SERVER_URL = process.env.REACT_APP_API_URL;


function PlanDetailsCard({ show,retailerType ,countryProps, is_telsim_plan, handleClose, countrySlug, planSlug, button, top, bottom }) {
  
  const [isLoading, setIsLoading] = useState(true);
  const [planDetails, setPlanDetails] = useState([]);
  const [planData, setPlanData] = useState('');
  const [supportedCountries, setsupportedCountries] = useState([]);
  const [relatedPlans, setRelatedPlans] = useState([]);
  const [surchargeAmount, setSurchargeAmount] = useState(null);
  const [surchargePercentage, setSurchargePercentage] = useState(0);
  const [extraSurcharge, setExtraSurcharge] = useState(0)
  const [total, setTotal] = useState(null)
  const [telsimPlanFeature, setTelsimPlanFeature] = useState([])
  const [supportedNetworks, setSupportedNetworks] = useState([])
  const sessionid = sessionStorage.getItem("sessionId")
  const [showModal, setShowModal] = useState(false);
  const [PlanType, setPlanType] = useState('');

  const [controller, dispatch] = useSoftUIController();
  const [isBackNavigation, setIsBackNavigation] = useState(false);
  const previousPathname = useRef(location.pathname);

  const [searchTerm, setSearchTerm] = useState("");

  const filteredCountries = supportedCountries.filter((country) =>
    country.country_name.toLowerCase().includes(searchTerm.toLowerCase())
  );
  
  const navigate = useNavigate();

 
  const isTelsimPlan = is_telsim_plan ? true : false;

  const cardStyles = {
    background: `linear-gradient(to bottom, ${bottom || '#000'} 0%, ${top || '#D6060D'} 100%)`,
    color: 'white'
  };

  const buttonStyle = {
    background: `${button}`,
    color: 'white!important',
    fontSize: '12px!important',
    width: '100%'
  };

  const handleSupportedCountriresOpenModal = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setMiniSidenav(dispatch, false);
    handleClose();
  };

  const modalRef = useRef(null);

  useEffect(() => {
    getPlanDetails(countrySlug, planSlug);

    const handleEscapeKey = (event) => {
    
      if (event.key === "Escape") {
        setMiniSidenav(dispatch, false);
        handleClose();
      }
    };

    const handleClickOutside = (event) => {

      // const activeElement = document.activeElement;
      // const isInputField = activeElement.className === "btn btn-custom btn-block value-btn";

      //  if (!isInputField) {
      //   setMiniSidenav(dispatch, false)
      //  }

      if (modalRef.current && !modalRef.current.contains(event.target)) {
        setMiniSidenav(dispatch, false);
        handleClose();
      }
      
    };

    if (show) {
      document.addEventListener('keydown', handleEscapeKey);
      document.addEventListener('mousedown', handleClickOutside);
      
    } else {
      document.removeEventListener('keydown', handleEscapeKey);
      document.removeEventListener('mousedown', handleClickOutside);
      
    }

    return () => {
      document.removeEventListener('keydown', handleEscapeKey);
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [show, handleClose, countrySlug, planSlug]);

  const getPlanDetails = async (countrySlug, planSlug) => {
     
    const headers = await getApiHeader();
    try {

      const res = await axios.get(`${SERVER_URL}international-esim/plan-details/${countrySlug}/${planSlug}`, {
        headers: headers
      });

      if (res.status === 200) {
        const planData = res.data.data;
        
        if (planData) {
          setPlanType(res.data.data.PlanType)

          if (res.data.data.PlanType === 'Country') {
            setsupportedCountries([
                {
                    country_id: countryProps.country_id,
                    country_name: countryProps.country_name,
                    flag_image: countryProps.flag_image,
                    supported_countries_id: "6"
                }
            ]);
        } else {
            setsupportedCountries(planData.supported_countries);
        }
          

          setRelatedPlans(planData.related_plans);
          setPlanData(planData.plan);
          setSurchargeAmount(planData.surcharge_amount)
          setExtraSurcharge(planData.extra_surcharge)
          setSurchargePercentage(planData.surcharge_percentage)
          setTotal(planData.total)
          if (planData.plan_features) {
            setTelsimPlanFeature(planData.plan_features)
          }
          if (res.data.data.supported_networks) {
            
            setSupportedNetworks(res.data.data.supported_networks)
            
          }
          if (planData.plan_details) {
            setPlanDetails(planData.plan_details);
          } else {
            console.error('Unexpected response structure:', res.data);
          }
        } else {
          console.error('Unexpected response structure:', res.data);
        }
      } else {
        console.log("Error: Unexpected status code", res.status);
      }
    } catch (error) {
      console.error("Error fetching country list:", error);

      navigate('/#', { replace: true });
    } finally {
      setIsLoading(false);
    }
  };
  const handleBuyClick = (data) => {
    setMiniSidenav(dispatch, false);
    const stateData = {
        plan_id:data.plan_id,
        plan_name: data.plan_name,
        plan_validity: data.plan_validity,
        plan_slug: data.plan_slug,
        retailerType:retailerType,
        actual_amount: retailerType === "PAR" 
            ? (data.prosegur_amount ?? '') 
            : data.rtap_amount,
        plan_amount:retailerType === "PAR" 
        ? (data.prosegur_amount ?? '') 
        : data.rtap_dealer_amount,
    };

    navigate("/activate_travel_esim/order-checkout", { replace: true, state: { stateData } });
};

  const modalClass = show ? "modal fade show d-block" : "modal fade";
  const modalBackdropClass = show ? "modal-backdrop fade show" : "modal-backdrop fade";

  useEffect(() => {

    setMiniSidenav(dispatch, true);
    // const element = document.querySelector('.MuiDrawer-docked ');
    
  }, []);


  return (
    <>
      {isLoading ? (
         <Backdrop
         open={true}
         style={{
             color: '#fff',
             zIndex: 9999,
         }}
     >
         <CircularProgress color="inherit" />
     </Backdrop>
      ) : (


        <div className={modalClass} id="packageModal" tabIndex="-1" aria-labelledby="packageModalLabel" aria-hidden="true" style={{ display: show ? "block" : "none" }}>
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content" ref={modalRef}>
              <div className="modal-body">
                <div className="modal-card-box" style={cardStyles}>
                  <div className="row">
                    <div className="col-lg-12 col-md-12 col-sm-12 modal-header">
                      <h5 className="modal-title" id="packageModalLabel" translate="no">{planData.common_plan_name}</h5>
                      <button
                        type="button"
                        style={{ buttonStyle }}
                        className="btn-close close"
                        onClick={handleCloseModal}
                        aria-label="Close">
                      </button>
                    </div>
                    <div className="col-lg-6 col-md-12 col-md-12 text-center">
                      <img src={planData.plan_image} className="img-fluid" title={planData.img_title} alt={planData.img_alt} />
                    </div>
                    <div className="col-lg-6 col-md-12 col-md-12">
                      <div className="card-body">
                        <center>
                          <table className="info-table">
                            <tbody>
                              <tr>
                                <td className="left-column"><i className="fas fa-globe" style={{ margin: "5px"}}></i>COVERAGE</td>
                                <td className="right-column" translate="no">{planData.plan_coverage}</td>
                              </tr>
                              <tr>
                                <td className="left-column"><i className="fas fa-wifi" style={{ margin: "5px"}}></i> DATA</td>
                                <td className="right-column">{planData.plan_data} GB</td>
                              </tr>
                              <tr>
                                <td className="left-column"><i className="fas fa-calendar-check" style={{ margin: "5px"}}></i> VALIDITY</td>
                                <td className="right-column"> {planData.plan_validity ? `${planData.plan_validity} ${planData.plan_validity === 1 ? "Day" : "Days"}` : ""}</td>
                              </tr>
                              <tr>
                                <td className="left-column"><i className="fas fa-tag" style={{ margin: "5px"}}></i> PRICE</td>
                                <td className="right-column"> AU $ {retailerType === "PAR" ? (planData.prosegur_amount ?? '') : planData.rtap_amount}  </td>
                              </tr>
                            </tbody>
                          </table>
                        </center>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-6 col-md-12 col-sm-12">
                    <div className="supported-country">
                      {isTelsimPlan === true && (
                        <>
                          <div className="card-info"  >
                            {telsimPlanFeature.map((feature) => (
                              <>
                                <p key={feature.plan_feature_id} style={{ fontSize: "14px" }}></p>
                                <p> {feature.feature_text}</p>
                              </>
                            ))}
                            {planData.country_flags_image ? (
                              <center>
                                <img src={planData.country_flags_image} style={{ marginLeft: "-27px" }} alt="Country Flags" />
                              </center>
                            ) : <br />}
                          </div>
                        </>
                      )}
                      <h5>Supported Countries</h5>
                      <center>
                        <div style={{ height: isTelsimPlan === true ? planData.country_flags_image ? "85px" : "165px" : "300px", maxHeight: '300px', overflowY: 'auto' }}>
                            {supportedCountries.length > 5 && (
                              <input
                                type="text"
                                placeholder="Search countries..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                 className="supported-search-input"
                              />
                            )}
                            <table className="info-table">
                              <tbody>
                                {filteredCountries.map((country, j) => (
                                  <tr key={j}>
                                  <td className="left-column" style={{color: "#000"}} translate="no">{country.country_name}</td>
                                    <td className="right-column">
                                      <img
                                        src={country.flag_image}
                                        alt={country.country_name}
                                        style={{ width: '60px' }}
                                      />
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                      </center>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-12 col-sm-12">
                    <div className="additional-info">
                      <h5>Additional Information</h5>
                      <div className="info-section" style={{ height: '300px', maxHeight: '300px', overflowY: 'auto' }}>

                        <div className="info-item">
                          {supportedNetworks.length > 6 && (
                            <>

                              <div className="info-title"> <i className="fas fa-signal"></i> Network</div>
                              <p onClick={handleSupportedCountriresOpenModal}>Check Supported Networks</p>
                            </>
                          )}
                          {planDetails.map((detail) => (
                            <>
                              <div className="info-title" key={detail.specification_id}> <i className={detail.specification_icon}></i> {detail.specification_name}</div>
                              <div className="info-content">
                                {detail.specification_value}
                                {detail.specification_value_1 && <span>, {detail.specification_value_1}</span>}
                                {detail.specification_value_2 && <span>, {detail.specification_value_2}</span>}
                                {detail.specification_value_3 && <span>, {detail.specification_value_3}</span>}
                              </div>
                            </>

                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                  
                </div>
              </div>
              <div className="modal-footer">
                <h5 className="modal-price"></h5>
                <button
                  type="button"
                  className="btn modal-btn"
                  style={buttonStyle}
                  onClick={() => handleBuyClick(planData)}
                >
                  AU $ {retailerType === "PAR" ? (planData.prosegur_amount ?? '') : planData.rtap_dealer_amount}  - Buy Now
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {show && <div className={modalBackdropClass} onClick={handleClose}></div>}

      {showModal && (
        <div className="supportedNetworkModal">
          <div className="supportedNetworkModal-content">
            <span className="close" onClick={handleCloseModal}>&times;</span>
            <h2>Supported Networks </h2>

            <table className="supported-network-table">
              <thead>
                <tr>
                  <th>Country</th>
                  <th>Networks</th>
                </tr>
              </thead>
              <tbody>
                {supportedNetworks.map((countryData, idx) => (
                  <tr key={idx}>
                    <td className="country-cell">
                      {countryData?.country_list ? (
                        <>
                          <img
                            src={countryData.country_list.flag_image}
                            alt={`${countryData.country_list.country_name} flag`}
                            className="network-flag"
                          />
                          <span className="country-name">
                            {countryData.country_list.country_name}
                          </span>
                        </>
                      ) : (
                        <p>No country data available</p>
                      )}
                    </td>
                    <td>
                      {PlanType === "Global" ? (
                        countryData?.country_list?.global_supported_networks?.length > 0 ? (
                          countryData.country_list.global_supported_networks.map((network, index) => (
                            <div key={index}>
                              <span>{network.network}</span>
                              <span>({network.network_type})</span>
                            </div>
                          ))
                        ) : (
                          <span>No global networks available</span>
                        )
                      ) : PlanType === "Region" ? (
                        countryData?.country_list?.region_supported_networks?.length > 0 ? (
                          countryData.country_list.region_supported_networks.map((network, index) => (
                            <div key={index}>
                              <span>{network.network}</span>
                              <span>({network.network_type})</span>
                            </div>
                          ))
                        ) : (
                          <span>No regional networks available</span>
                        )
                      ) : (
                        <span>Invalid PlanType</span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </>
  );
}

export default PlanDetailsCard;
